<template>
  <v-card
    max-width=480
    min-width=390
    class="mx-auto"
    
  >      <v-row justify="space-between">
        <v-card-title class="pt-2 pr-2">

       <v-avatar size=42 color="primary">
       <span class="white--text text-h6">{{ initials }}</span>
      </v-avatar>

          <div class="text-body-1 pl-2 font-weight-bold">
            {{ contact.Name }}
          </div>
              </v-card-title>          
            <v-btn
            dark
            icon
            class="pr-4"
          >
        <v-icon color="grey">mdi-pencil</v-icon>
          </v-btn>

       <!-- <v-card-title>
          <v-btn
            dark
            icon
            class="mr-2"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            dark
            icon
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-card-title> -->
        


    </v-row>
     <v-list v-if="contact.JobDesc">
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-sitemap
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ contact.JobDesc }}</v-list-item-title>
          <v-list-item-subtitle>Θέση</v-list-item-subtitle>
        </v-list-item-content>
        </v-list-item>
        </v-list>
     <v-divider inset></v-divider>
    <v-list two-line>
      <v-list-item v-if="contact.Mobile">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-phone
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ contact.Mobile }}</v-list-item-title>
          <v-list-item-subtitle>Mobile</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon>
          <v-icon>mdi-message-text</v-icon>
        </v-list-item-icon>
      </v-list-item>

      <v-list-item v-if="contact.Telephone">
      <v-list-item-icon>
          <v-icon color="primary">
            mdi-phone-classic
          </v-icon>
        </v-list-item-icon>
         
        <v-list-item-content>
          <v-list-item-title>{{ contact.Telephone }}</v-list-item-title>
          <v-list-item-subtitle>Work</v-list-item-subtitle>
        </v-list-item-content>

      </v-list-item>

      <v-divider  v-if="contact.Email" inset></v-divider>

      <v-list-item v-if="contact.Email">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-email
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ contact.Email }}</v-list-item-title>
          <v-list-item-subtitle>Personal</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>


      <v-divider v-if="contact.Address" inset></v-divider>

      <v-list-item v-if="contact.Address">
        <v-list-item-icon>
          <v-icon color="indigo">
            mdi-map-marker
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ contact.Address }}</v-list-item-title>
          <v-list-item-subtitle>Orlando, FL 79938</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'ContactDetails',
  props: {
    contact: { required: true, type: Object },
  },
  components: {
  },
  computed: {
    name () {
        return this.contact.Name.split(" ")[0]
    },
     initials () {
        let n = this.contact.Name.split(" ");
        return n[0][0] + n[1][0];
    },
    lastName () {
        return this.contact.Name.split(" ")[1]
    },
  },
  watch: {
   // async invoiceId () { await this.fetchInvoice(); },
  },
  data() {
    return {
      loading: true,
    };
  },
}
</script>
